'use client'

import {ReactNode, useState} from 'react'
import s from './style.module.scss'
import LogoAndText from './logo-and-text'
import CollapseArrow from './collapse-arrow'
import ExpandedFooter from './expanded-footer'
import clsx from 'clsx'

interface Props {
  logo: ReactNode
  isMobile: boolean
  footerlinks: ReactNode
  langTranslate: Record<string, string>
}

const FooterClient = ({logo, isMobile, langTranslate, footerlinks}: Props) => {
  const [isExpanded, setExpanded] = useState<boolean>(false)
  const showExpanded = isExpanded || !isMobile
  return (
    <footer
      className={clsx(s.intro_footer, {
        [s.desktop_footer]: !isMobile,
      })}
    >
      <div className={clsx(s.foot_container, {[s.apart]: !showExpanded})} data-testid='intro-footer-section'>
        {showExpanded ? (
          <ExpandedFooter
            isMobile={isMobile}
            logo={logo}
            isActive={isExpanded}
            footerlinks={footerlinks}
            langTranslate={langTranslate}
            toggleState={() => setExpanded((hasExpanded) => !hasExpanded)}
          />
        ) : (
          <>
            <LogoAndText hideText={false} logo={logo} />
            <CollapseArrow isActive={isExpanded} toggleState={() => setExpanded((hasExpanded) => !hasExpanded)} />
          </>
        )}
      </div>
    </footer>
  )
}

export default FooterClient
